import React, { useEffect, useRef, useState } from "react"

import { useIntl } from "react-intl"

import FormattedMarkdown from "./formatted_markdown"

const articles = [
  {
    id: "about-belgacoin",
    translationKey: "SupportArticles.aboutBelgacoin",
  },
  {
    id: "buy-sell-ended",
    translationKey: "SupportArticles.buySellEnded",
  },
  {
    id: "convert-bitcoins-to-euros",
    translationKey: "SupportArticles.convertBitcoinsToEuros",
  },
  {
    id: "what-is-belgacoin",
    translationKey: "SupportArticles.whatIsBelgacoin",
  },
  {
    id: "how-long-does-it-take",
    translationKey: "SupportArticles.howLongDoesItTake",
  },
  {
    id: "how-much-does-it-cost",
    translationKey: "SupportArticles.howMuchDoesItCost",
  },
  {
    id: "buy-sell-limits",
    translationKey: "SupportArticles.buySellLimits",
  },
  {
    id: "exchange-rate-guaranteed",
    translationKey: "SupportArticles.exchangeRateGuaranteed",
  },
  {
    id: "anonymous-service",
    translationKey: "SupportArticles.anonymousService",
  },
  {
    id: "payment-methods",
    translationKey: "SupportArticles.paymentMethods",
  },
  {
    id: "returned-payment",
    translationKey: "SupportArticles.returnedPayment",
  },
  {
    id: "wallet",
    translationKey: "SupportArticles.wallet",
  },
  {
    id: "wallet-cost",
    translationKey: "SupportArticles.walletCost",
  },
  {
    id: "wallet-limits",
    translationKey: "SupportArticles.walletLimits",
  },
  {
    id: "identity",
    translationKey: "SupportArticles.identity",
  },
  {
    id: "identity-timing",
    translationKey: "SupportArticles.identityTiming",
  },
  {
    id: "bots",
    translationKey: "SupportArticles.bots",
  },
  {
    id: "cryptolocker-assistance",
    translationKey: "SupportArticles.cryptolockerAssistance",
  },
]

const SupportArticleList = () => {
  const intl = useIntl()
  const [activeArticleId, setActiveArticleId] = useState(articles[0].id)
  const indexLinkRefs = useRef({})

  useEffect(() => {
    const articleElements = articles
      .map(article => document.getElementById(article.id))
      .filter(Boolean)

    const setActiveArticle = () => {
      const activeArticle = articleElements.reduce(
        (currentArticle, articleElement) => {
          if (articleElement.getBoundingClientRect().top <= 120) {
            return articleElement
          }

          return currentArticle
        },
        articleElements[0]
      )

      if (activeArticle) {
        setActiveArticleId(activeArticle.id)
      }
    }

    setActiveArticle()
    window.addEventListener("scroll", setActiveArticle, { passive: true })
    window.addEventListener("resize", setActiveArticle)

    return () => {
      window.removeEventListener("scroll", setActiveArticle)
      window.removeEventListener("resize", setActiveArticle)
    }
  }, [])

  useEffect(() => {
    const activeIndexLink = indexLinkRefs.current[activeArticleId]

    if (
      activeIndexLink &&
      window.matchMedia("(min-width: 992px)").matches
    ) {
      activeIndexLink.scrollIntoView({
        block: "nearest",
        inline: "nearest",
      })
    }
  }, [activeArticleId])

  return (
    <div className="support-layout">
      <aside className="support-index">
        <ul className="nav nav-pills flex-column">
          {articles.map(article => (
            <li className="nav-item" key={article.id}>
              <a
                ref={element => {
                  indexLinkRefs.current[article.id] = element
                }}
                className={
                  "nav-link mb-1 " +
                  (activeArticleId == article.id ? "active" : "")
                }
                href={"#" + article.id}
                onClick={event => {
                  event.preventDefault()
                  setActiveArticleId(article.id)

                  document.getElementById(article.id).scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  })
                }}
              >
                {intl.formatMessage({
                  id: article.translationKey + ".title",
                })}
              </a>
            </li>
          ))}
        </ul>
      </aside>
      <div className="support-article-list">
        {articles.map(article => (
          <article className="support-article" id={article.id} key={article.id}>
            <h3>
              {intl.formatMessage({
                id: article.translationKey + ".title",
              })}
            </h3>
            <FormattedMarkdown id={article.translationKey + ".article"} />
          </article>
        ))}
      </div>
    </div>
  )
}

export default SupportArticleList
